import PropTypes from "prop-types";
import { MealPlannerHeader } from "./components/MealPlannerHeader";
import { MealPlannerWeekSelector } from "./components/MealPlannerWeekSelector";
import { MealPlannerWeekResume } from "./components/MealPlannerWeekResume";
import MealClipboardContent from "../../../../parts/MealClipboardContent";

/**
 * DetailedMealPlanner
 * 
 * Main component for detailed meal plans
 * Uses weeks structure with specific dates for each day
 */
export const DetailedMealPlanner = ({ locals, planMode, api }) => {
  const { mealPlan } = locals;
  const { query } = locals;
  const { viewMode } = query;

  return (
    <main role="nutrition-wrapper" className="Nutrition meal-planner-main">
      <MealPlannerHeader mealPlan={mealPlan} locals={locals} planMode={planMode} />
      {!viewMode && (
        <MealPlannerWeekSelector mealPlan={mealPlan} query={locals.query} />
      )}
      <MealPlannerWeekResume mealPlan={mealPlan} locals={locals} api={api} />
      <MealClipboardContent
        query={query.mealsInClipboard}
        locals={locals}
      />
    </main>
  );
};

DetailedMealPlanner.propTypes = {
  locals: PropTypes.object,
  planMode: PropTypes.string,
};

